import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { CountryCode, getMultiTenancyHeaders } from '../utils/multiTenancyHeaders';
import { GetKlaviyoCustomerApiResponse, UnsubscribeResponse, SubscriptionType } from './types';

export type OnlineMarketingApiClientConstructorArgs = {
  onlineMarketingApiBaseUrl: string;
  onlineMarketingApiKey?: string;
  countryCode: CountryCode;
};

export class OnlineMarketingApiClient extends ApiClient {
  private readonly _onlineMarketingApiBaseUrl: string;
  private readonly _onlineMarketingApiKey?: string;
  private readonly _countryCode: CountryCode;

  constructor({
    onlineMarketingApiBaseUrl,
    onlineMarketingApiKey,
    countryCode,
  }: OnlineMarketingApiClientConstructorArgs) {
    super();
    this._onlineMarketingApiBaseUrl = onlineMarketingApiBaseUrl;
    this._onlineMarketingApiKey = onlineMarketingApiKey;
    this._countryCode = countryCode;
  }

  override get requestHeaders(): Record<string, string> {
    return {
      ...super.requestHeaders,
      ...getMultiTenancyHeaders(this._countryCode),
      ...(this._onlineMarketingApiKey ? { 'x-jbg-api-key': this._onlineMarketingApiKey } : {}),
    };
  }
  async getKlaviyoCustomer(kx: string): Promise<ApiResponse<GetKlaviyoCustomerApiResponse>> {
    const { data, statusCode, error } = await this._fetch<GetKlaviyoCustomerApiResponse>({
      path: `${this._onlineMarketingApiBaseUrl}/GetKlaviyoCustomer?id=${kx}`,
      method: 'GET',
    });

    if (error) {
      return { error, statusCode };
    }

    return { data, error, statusCode };
  }

  async unsubscribe({
    klaviyoId,
    subscriptions,
  }: {
    klaviyoId: string | null;
    subscriptions: Array<SubscriptionType>;
  }): Promise<ApiResponse<UnsubscribeResponse>> {
    const { data, statusCode, error } = await this._fetch<UnsubscribeResponse>({
      path: `${this._onlineMarketingApiBaseUrl}/Unsubscribe`,
      method: 'POST',
      body: JSON.stringify({
        klaviyoId,
        subscriptions,
      }),
    });

    return { data, statusCode, error };
  }
}
